import React from "react";
import './App.css';
import { Routes, Route } from "react-router-dom"; // حذف BrowserRouter
import { HelmetProvider } from "react-helmet-async";
import Home from "./Pages/Home";
import Roadmap from "./Pages/Roadmap";
import Artstudio from "./Pages/Artstudio";
import Art from "./Pages/Art";
import Cs from "./Pages/Cybersoul";

function App() {
  return (
    <HelmetProvider>
        <main>
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/art" element={<Art />} />
            <Route path="/artstudio" element={<Artstudio />} />
            <Route path="/Cybersoul" element={<Cs />} />
          </Routes>
          </div>
        </main>
    </HelmetProvider>
  );
}

export default App;

